import { useRouter } from 'next/router';
import React from 'react';
import { PAGE_SLUG } from '../common/constants';
import CustomLink from './CustomLink';

function SubNavigation({ menuItems = [], subNavbarMenuId }) {
  const router = useRouter();
  const { pathname, asPath } = router;

  const { subMenuItems, shouldShow } = React.useMemo(() => {
    if (!menuItems || menuItems.length === 0)
      return { subMenuItems: [], shouldShow: false };

    let parentMenuItems;
    if (subNavbarMenuId) {
      const matchedMenu = menuItems?.find(
        (menu) => menu?.id === subNavbarMenuId && menu?.menuItems?.length > 0
      );

      if (!matchedMenu) return { subMenuItems: [], shouldShow: false };
      parentMenuItems = matchedMenu?.menuItems;
    } else {
      return { subMenuItems: [], shouldShow: false };
      // commented for future use
      // const normalizedAsPath = normalizePath(asPath);
      // const normalizedPathname = normalizePath(pathname);

      // const foundParentMenu =
      //   findParentMenuForPathname(normalizedAsPath, menuItems) ||
      //   findParentMenuForPathname(normalizedPathname, menuItems);
      // if (!foundParentMenu || !foundParentMenu.menuItems) {
      //   return { subMenuItems: [], shouldShow: false };
      // }
      // parentMenuItems = foundParentMenu?.menuItems;
    }

    const subMenuItemsCopy = [...parentMenuItems];
    subMenuItemsCopy.sort((a, b) => {
      const orderA = a?.order ?? 0;
      const orderB = b?.order ?? 0;
      return orderA - orderB;
    });

    return {
      subMenuItems: subMenuItemsCopy,
      shouldShow: subMenuItemsCopy.length > 0
    };
  }, [menuItems, subNavbarMenuId]);

  if (!shouldShow || !subMenuItems || subMenuItems.length === 0) {
    return null;
  }

  const isActive = (menu) => {
    if (!menu?.url) return false;

    if (menu?.type === 'INTERNAL') {
      const internalPath = `${PAGE_SLUG[menu?.internalPageType] ?? ''}${
        menu?.url === '/' ? '' : '/'
      }${menu?.url}`;
      return asPath === internalPath || pathname === internalPath;
    }

    return asPath === menu?.url || pathname === menu?.url;
  };

  return (
    <nav className="sub-navigation">
      <div className="container">
        <div className="sub-navigation-wrapper">
          {subMenuItems.map((menu) => {
            const active = isActive(menu);
            return (
              <div
                key={menu?.id || menu?.url}
                className={`sub-nav-item ${active ? 'active' : ''}`}
              >
                <CustomLink
                  name={menu?.name?.en || menu?.name || ''}
                  url={menu?.url}
                  type={menu?.type}
                  internalPageType={menu?.internalPageType}
                  target={menu?.openInSameTab ? '_self' : '_blank'}
                />
              </div>
            );
          })}
        </div>
      </div>
    </nav>
  );
}

export default SubNavigation;
